import * as React from "react"
import { useRouteMatch } from "react-router-dom"
import { StickySentinel } from "@digits-shared/components/Responsive/StickySentinel"
import { HeaderActions } from "@digits-shared/DesignSystem/Containers/Headers/HeaderActions"
import { HeaderCenteredButtons } from "@digits-shared/DesignSystem/Containers/Headers/HeaderButtons"
import { DigitsLinkButton } from "@digits-shared/DesignSystem/LinkButton"
import styled from "styled-components"
import { ViewEditToggle } from "src/frontend/components/OS/Applications/Shared/Accounting/ViewEditButtons"
import { useAllowTransactionsTableEdits } from "src/frontend/components/Shared/Transactions/Updates/useAllowTransactionsTableEdits"
import routes from "src/frontend/routes"

export const AnalysisToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .mobile & {
    flex: 1;

    ${DigitsLinkButton} {
      flex: 1;
    }
  }
`

export const AnalysisHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  const ref = React.useRef<HTMLDivElement>(null)

  const expensesTransactions = !!useRouteMatch(routes.expenseTransactions.parameterizedPath)
  const revenueTransactions = !!useRouteMatch(routes.revenueTransactions.parameterizedPath)
  const { allowEdits } = useAllowTransactionsTableEdits()
  const showEditToggle = allowEdits && (expensesTransactions || revenueTransactions)

  return (
    <>
      <StickySentinel stickRef={ref} rootMargin="-45px 0px 0px" />
      <HeaderActions ref={ref}>
        {children}
        {showEditToggle && (
          <HeaderCenteredButtons>
            <ViewEditToggle />
          </HeaderCenteredButtons>
        )}
      </HeaderActions>
    </>
  )
}
